export const userAgreementContent = {
  en: {
    title: 'User Agreement',
    updated: 'Last updated: May 10, 2023',
    html: `
      <h2>Terms of Service</h2>
      <p>
        These Terms of Service apply to your use of TimeEcho, our website at https://lovetime.life, and any related services we provide.
      </p>
      <p>
        By using TimeEcho, you agree to comply with these Terms and all applicable laws and regulations. If you do not agree with these Terms, you are prohibited from continuing to use the app, accessing our website, or using any other services provided by TimeEcho.
      </p>
      <p>
        If you access or download TimeEcho from the Apple App Store, you agree to any usage rules set out in the App Store Terms of Service.
      </p>
      <p>
        We reserve the right, at our sole discretion, to review and modify these Terms at any time. Any changes become effective immediately upon publication.
      </p>

      <h2>Restrictions on Use</h2>
      <p>
        By using TimeEcho and our website, you represent and warrant, on behalf of yourself, any entity you represent, and your users, that you will not:
      </p>
      <ol>
        <li>modify, copy, prepare derivative works of, decompile, or reverse engineer TimeEcho or any materials and software contained in TimeEcho or on our website;</li>
        <li>remove any copyright or other proprietary notices from materials and software contained in TimeEcho or on our website;</li>
        <li>transfer TimeEcho or related materials to another person, or mirror such materials on any other server;</li>
        <li>intentionally or unintentionally use TimeEcho or related services in a way that abuses or disrupts our network or any other services;</li>
        <li>use TimeEcho or related services to transmit or publish any harassing, indecent, obscene, fraudulent, or unlawful material;</li>
        <li>use TimeEcho or related services in violation of any applicable laws or regulations;</li>
        <li>use TimeEcho to send unauthorized advertising or spam;</li>
        <li>collect, harvest, or gather user data without user consent;</li>
        <li>use TimeEcho or related services in any way that may infringe the privacy rights, intellectual property rights, or other rights of third parties.</li>
      </ol>

      <h2>Intellectual Property</h2>
      <p>
        The intellectual property in the materials on our website belongs to TimeEcho and its founding team. You may download TimeEcho and view, use, and display the app on your mobile device for personal use only.
      </p>
      <p>
        This constitutes a grant of license, not a transfer of title. This license automatically terminates if you violate any of these restrictions or these Terms, and TimeEcho may terminate it at any time.
      </p>

      <h2>Automatic Updates</h2>
      <p>
        You allow us to download and install TimeEcho updates on your device according to your privacy preferences. You may withdraw this permission at any time by deleting TimeEcho from your device.
      </p>

      <h2>Liability</h2>
      <p>
        TimeEcho and the materials on our website are provided on an “as is” basis. To the maximum extent permitted by law, we make no express or implied warranties and expressly disclaim all other warranties, including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, non-infringement of intellectual property, or other violation of rights.
      </p>
      <p>
        In no event will the TimeEcho team or its suppliers be liable for any indirect loss suffered or incurred by you or any third party arising out of or in connection with the use of, or inability to use, TimeEcho, our website, any other services provided, or materials in TimeEcho, even if the TimeEcho team or an authorized representative has been advised, orally or in writing, of the possibility of such damage.
      </p>
      <p>
        In these Terms, “indirect loss” includes any indirect loss, loss of actual or anticipated profit, loss of benefit, loss of revenue, loss of business, loss of goodwill, loss of opportunity, loss of savings, loss of reputation, loss of use, and/or loss or corruption of data, whether under statute, contract, equity, tort (including negligence), indemnity, or otherwise.
      </p>
      <p>
        Some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages. In such jurisdictions, these limitations may not apply to you.
      </p>

      <h2>Pro Subscription Agreement</h2>
      <ol>
        <li>
          After activating a paid Pro subscription, you may continuously access all Pro features in TimeEcho during the subscription period. (Note: subscriptions are strongly tied to Apple ID. Switching Apple ID while using the app may cause data errors, and you are responsible for related risks.)
        </li>
        <li>
          Continuous monthly and continuous yearly subscriptions are auto-renewal services provided to you after you enable Pro. By enabling either plan, you authorize TimeEcho to charge the service fee for the next billing cycle from your account(s) (including your prepaid balance account, third-party payment account linked to TimeEcho, bank card, telecom account, iTunes account, etc.) before your current period expires. Charges are typically made within 24 hours before expiry. You must ensure linked accounts are valid and have sufficient balance. If renewal fails due to insufficient balance, you shall bear the consequences.
        </li>
        <li>
          If Pro is not activated after payment: update to the latest app version, then tap “Restore Purchases” in the Pro center page. If the issue persists, contact us at solovetime@163.com.
        </li>
      </ol>

      <h2>Apple Notice</h2>
      <p>
        Regarding your use of TimeEcho on iOS devices, you acknowledge and agree that these Terms are between you and TimeEcho only, not Apple Inc. (“Apple”), and Apple is not responsible for TimeEcho or any materials available in TimeEcho.
      </p>
      <p>
        Apple has no obligation whatsoever to furnish any maintenance and support services for TimeEcho.
      </p>
      <p>
        If TimeEcho fails to conform to any applicable warranty, you may notify Apple, and Apple may refund the purchase price of the mobile app. To the maximum extent permitted by applicable law, Apple has no other warranty obligations with respect to TimeEcho, and any other claims, losses, liabilities, damages, costs, or expenses attributable to any failure to conform to any warranty are our responsibility.
      </p>
      <p>
        Apple is not responsible for addressing any claims by you or any third party relating to TimeEcho or your possession and/or use of TimeEcho, including but not limited to: (1) product liability claims; (2) claims that our app fails to conform to any applicable legal or regulatory requirement; and (3) claims arising under consumer protection or similar legislation.
      </p>
      <p>
        Apple is not responsible for the investigation, defense, settlement, or discharge of any third-party claim that our app infringes that third party’s intellectual property rights.
      </p>
      <p>
        You agree to comply with any applicable third-party terms when using TimeEcho, including any usage rules set out in the Apple App Store Terms of Service.
      </p>
      <p>
        Apple and Apple’s subsidiaries are third-party beneficiaries of these Terms. Upon your acceptance, Apple will have the right (and will be deemed to have accepted the right) to enforce these Terms against you as a third-party beneficiary.
      </p>

      <h2>Governing Law and Updates</h2>
      <p>
        We may revise these Terms from time to time due to changes in laws, regulations, or operational needs, and publish updates as required by law. Updated Terms take effect upon publication and replace prior versions. You should review the latest Terms and announcements periodically. If you do not agree with updated Terms, you may immediately stop using our products and/or services. Continued use constitutes full acceptance of the updated Terms. If any provision is determined by a judicial or administrative authority to be invalid or unenforceable, that provision will be severable and will not affect the validity and enforceability of the remaining provisions.
      </p>
      <p>
        These Terms are governed by and interpreted in accordance with the laws of the People’s Republic of China. In case of disputes, both users and the TimeEcho team agree that disputes shall be submitted to the local People’s Court with jurisdiction. If you have any questions regarding these Terms, please contact us at <a href="mailto:solovetime@163.com">solovetime@163.com</a>.
      </p>
    `,
  },
  'zh-Hans': {
    title: '用户协议',
    updated: '最近更新：2023年5月10日',
    html: `
      <h2>服务条款</h2>
      <p>
        这些服务条款适用于您对 时间印迹、我们位于 https://lovetime.life 的网站以及提供的任何相关服务的使用。
      </p>
      <p>
        当您使用 时间印迹 时，您同意遵守这些服务条款并遵守所有适用的法律和法规。如果您不同意这些服务条款，您将被禁止进一步使用该应用程序、访问我们的网站或使用 时间印迹 提供的任何其他服务。
      </p>
      <p>
        如果您从 Apple App Store 访问或下载 时间印迹，您同意 App Store 服务条款中规定的任何使用规则。
      </p>
      <p>
        我们保留自行决定审查和修改任何这些服务条款的权利。对这些服务条款的任何更改将从发布之日起立即生效。
      </p>

      <h2>使用限制</h2>
      <p>
        通过使用 时间印迹 和我们的网站，您代表您自己、您所代表的任何已签署这些服务条款的实体以及您的用户保证您不会：
      </p>
      <ol>
        <li>修改、复制、准备 时间印迹 或我们网站上包含的任何材料和软件的衍生作品、反编译或反向工程；</li>
        <li>从 时间印迹 或我们网站上包含的任何材料和软件中删除任何版权或其他专有符号；</li>
        <li>将 时间印迹 或其任何相关材料转移给另一个人或将材料“镜像”到任何其他服务器上；</li>
        <li>以滥用或破坏我们的网络或任何其他服务的方式故意或无意地使用 时间印迹 或其任何相关服务；</li>
        <li>使用 时间印迹 或其相关服务传输或发布任何骚扰、不雅、淫秽、欺诈或非法材料；</li>
        <li>违反任何适用法律或法规使用 时间印迹 或其相关服务；</li>
        <li>使用 时间印迹 发送未经授权的广告或垃圾邮件；</li>
        <li>未经用户同意收集、收集或收集用户数据；</li>
        <li>以可能侵犯第三方隐私权、知识产权或其他权利的方式使用 时间印迹 或其相关服务。</li>
      </ol>

      <h2>知识产权</h2>
      <p>
        我们网站上的材料的知识产权归 时间印迹 及其创始团队所有。您可以下载 时间印迹，在您的移动设备上查看、使用和显示该应用程序，仅供您个人使用。
      </p>
      <p>
        这构成许可的授予，而不是所有权的转让。如果您违反任何这些限制或这些服务条款，该许可将自动终止，并且 时间印迹 可以随时终止。
      </p>

      <h2>自动更新</h2>
      <p>
        您允许我们根据您的隐私偏好在您的设备上下载和安装 时间印迹 的更新。通过从您的设备中删除 时间印迹，可以随时撤销此权限。
      </p>

      <h2>责任</h2>
      <p>
        时间印迹 以及我们网站上的材料均按“原样”提供。在法律允许的范围内，不作任何明示或暗示的保证，并特此否认并否定所有其他保证，包括但不限于适销性、特定用途适用性或不侵犯知识产权的暗示保证或条件，或其他侵犯权利的行为。
      </p>
      <p>
        在任何情况下，对于您或任何第三方因素使用或无法使用 时间印迹、我们的网站或提供的任何其他服务或 时间印迹 中的材料而遭受或招致的任何间接损失，时间印迹团队或其供应商概不负责，即使如果时间印迹团队或授权代表已被口头或书面通知此类损坏的可能性。
      </p>
      <p>
        在本协议的上下文中，“间接损失”包括任何间接损失、实际或预期的利润损失、利益损失、收入损失、业务损失、商誉损失、机会损失、储蓄损失、名誉损失、使用损失和/或数据丢失或损坏，无论是根据法规、合同、衡平法、侵权（包括疏忽）、赔偿或其他规定。
      </p>
      <p>
        由于某些司法管辖区不允许限制默示保证，或限制间接或附带损害的责任，因此这些限制可能对您不适用。
      </p>

      <h2>Pro订阅协议</h2>
      <ol>
        <li>
          经付费开启 Pro 订阅服务后，你可以在相应服务期限内持续访问 时间印迹 内 Pro 包含的全部功能。（注：订阅与 Apple ID 有强相关，使用 app 期间如果切换 Apple ID 可能导致数据错误，需自行负责。）
        </li>
        <li>
          连续包月和连续包年服务是在你已开启 Pro 订阅服务的前提下，向你提供的自动续费服务。如你开通连续包月或连续包年服务，则视为你授权「时间印迹」在你已开通的 Pro 订阅服务即将到期时，从你的自有充值账户、与「时间印迹」绑定的第三方支付账户、银行卡、通讯账号、iTunes 账户（简称“账户”）等代扣下一个计费周期的服务费用。扣费时间为计费周期到期前24小时内。你需要将「时间印迹」与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，你将自行承担相应结果。
        </li>
        <li>
          支付后 Pro 未到账的解决办法：如果您在订阅并支付后，Pro 服务未及时生效，请尝试更新至最新版 App，然后在 Pro 个人中心页点击“恢复购买”即可恢复 Pro 特权，如尝试后仍未解决，请联系我们（邮箱：solovetime@163.com）。
        </li>
      </ol>

      <h2>关于苹果的通知</h2>
      <p>
        就您在 iOS 设备上使用或访问 时间印迹 而言，您承认并同意本条款的条款。您承认这些服务条款仅在您和 时间印迹 之间，而不是在 Apple Inc.（Apple）之间，Apple 不对 时间印迹 和 时间印迹 中可用的任何材料负责。
      </p>
      <p>
        Apple 没有义务向您提供与 时间印迹 有关的任何维护和支持服务。
      </p>
      <p>
        如果 时间印迹 不符合任何适用的保证，您可以通知 Apple，Apple 将向您退还移动应用程序的购买价款。在适用法律允许的最大范围内，Apple 对 时间印迹 不承担任何其他保修义务，并且因未遵守任何保修而导致的任何其他索赔、损失、责任、损害、成本或费用将由我们负责。
      </p>
      <p>
        Apple 不负责处理您或任何第三方提出的与 时间印迹 或您使用 时间印迹 相关的任何索赔，包括但不限于（1）产品责任索赔；（2）任何声称我们的移动应用程序不符合任何适用的法律或监管要求；（3）根据消费者保护或类似立法产生的索赔。
      </p>
      <p>
        Apple 不负责调查、辩护、解决和解除任何第三方声称我们的移动应用程序侵犯第三方知识产权的索赔。
      </p>
      <p>
        您同意在使用 时间印迹 时遵守任何适用的第三方条款，包括 Apple App Store 服务协议中规定的任何使用规则。
      </p>
      <p>
        Apple 和 Apple 的子公司是本服务条款的第三方受益人，在您接受本服务条款后，Apple 将有权（并将被视为已接受该权利）对您执行本服务条款，因为这些服务条款的第三方受益人。
      </p>

      <h2>法律及协议更新</h2>
      <p>
        根据国家法律法规变化及网站运营需要，我们有权对本协议条款不时地进行修改，并根据国家法律法规的要求进行公示，修改后的协议在公示后生效并代替原来的协议。你应不时关注并阅读最新版的协议及网站公告。如你不同意更新后的新协议，你有权立即停止使用我们的产品和/或服务。如你继续使用我们的产品和/或服务，即视为完全同意更新后的协议。如果本协议中任何一条被司法或行政机关判定废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
      </p>
      <p>
        上述条款将受中华人民共和国法律的约束并依据其解释。如出现纠纷，用户和时间印迹团队一致同意将纠纷交由当地人民法院管辖。如用户对本服务条款内容有任何疑问，可发邮件至 <a href="mailto:solovetime@163.com">solovetime@163.com</a> 获取相关信息。
      </p>
    `,
  },
  'zh-Hant': {
    title: '使用者協議',
    updated: '最近更新：2023年5月10日',
    html: `
      <h2>服務條款</h2>
      <p>
        這些服務條款適用於您對 時間印跡、我們位於 https://lovetime.life 的網站以及提供的任何相關服務的使用。
      </p>
      <p>
        當您使用 時間印跡 時，您同意遵守這些服務條款並遵守所有適用的法律和法規。如果您不同意這些服務條款，您將被禁止進一步使用該應用程式、訪問我們的網站或使用 時間印跡 提供的任何其他服務。
      </p>
      <p>
        如果您從 Apple App Store 訪問或下載 時間印跡，您同意 App Store 服務條款中規定的任何使用規則。
      </p>
      <p>
        我們保留自行決定審查和修改任何這些服務條款的權利。對這些服務條款的任何變更將自發佈之日起立即生效。
      </p>

      <h2>使用限制</h2>
      <p>
        透過使用 時間印跡 和我們的網站，您代表您自己、您所代表的任何已簽署這些服務條款的實體以及您的使用者保證您不會：
      </p>
      <ol>
        <li>修改、複製、準備 時間印跡 或我們網站上包含的任何材料與軟體的衍生作品、反編譯或逆向工程；</li>
        <li>從 時間印跡 或我們網站上包含的任何材料與軟體中刪除任何版權或其他專有標記；</li>
        <li>將 時間印跡 或其任何相關材料轉移給另一個人或將材料「鏡像」到任何其他伺服器上；</li>
        <li>以濫用或破壞我們的網路或任何其他服務的方式故意或無意地使用 時間印跡 或其任何相關服務；</li>
        <li>使用 時間印跡 或其相關服務傳輸或發佈任何騷擾、不雅、淫穢、詐欺或非法材料；</li>
        <li>違反任何適用法律或法規使用 時間印跡 或其相關服務；</li>
        <li>使用 時間印跡 發送未經授權的廣告或垃圾郵件；</li>
        <li>未經使用者同意蒐集、收集或擷取使用者資料；</li>
        <li>以可能侵犯第三方隱私權、智慧財產權或其他權利的方式使用 時間印跡 或其相關服務。</li>
      </ol>

      <h2>智慧財產權</h2>
      <p>
        我們網站上的材料之智慧財產權歸 時間印跡 及其創始團隊所有。您可以下載 時間印跡，並在您的行動裝置上檢視、使用及顯示該應用程式，僅供您個人使用。
      </p>
      <p>
        這構成授予許可，而非所有權轉讓。若您違反任何限制或本服務條款，該許可將自動終止，且 時間印跡 可隨時終止該許可。
      </p>

      <h2>自動更新</h2>
      <p>
        您允許我們依據您的隱私偏好在您的裝置上下載與安裝 時間印跡 更新。您可隨時透過刪除 時間印跡 來撤回此權限。
      </p>

      <h2>責任</h2>
      <p>
        時間印跡 以及我們網站上的材料均按「現狀」提供。在法律允許範圍內，不提供任何明示或暗示保證，並在此否認所有其他保證，包括但不限於適銷性、特定用途適用性、不侵犯智慧財產權或其他權利之暗示保證或條件。
      </p>
      <p>
        在任何情況下，對於您或任何第三方因使用或無法使用 時間印跡、我們網站或提供的任何其他服務，或 時間印跡 中材料而遭受或招致的任何間接損失，時間印跡團隊或其供應商概不負責，即使時間印跡團隊或授權代表已被口頭或書面告知此類損害之可能性。
      </p>
      <p>
        在本協議語境中，「間接損失」包括任何間接損失、實際或預期利潤損失、利益損失、收入損失、業務損失、商譽損失、機會損失、儲蓄損失、名譽損失、使用損失及／或資料遺失或損壞，無論係基於法規、契約、衡平法、侵權（包括過失）、賠償或其他規定。
      </p>
      <p>
        由於某些司法轄區不允許限制默示保證，或限制對間接或附帶損害之責任，故此等限制可能不適用於您。
      </p>

      <h2>Pro 訂閱協議</h2>
      <ol>
        <li>
          經付費開啟 Pro 訂閱服務後，您可在相應服務期限內持續訪問 時間印跡 內 Pro 包含的全部功能。（註：訂閱與 Apple ID 強關聯，使用 app 期間如切換 Apple ID 可能導致資料錯誤，需自行承擔。）
        </li>
        <li>
          連續包月與連續包年服務是在您已開啟 Pro 訂閱服務前提下，向您提供的自動續費服務。若您開通連續包月或連續包年，則視為您授權「時間印跡」在已開通之 Pro 訂閱服務即將到期時，從您的自有儲值帳戶、與「時間印跡」綁定之第三方支付帳戶、銀行卡、通訊帳號、iTunes 帳戶（簡稱「帳戶」）等代扣下一個計費週期之服務費。扣費時間為計費週期到期前 24 小時內。您需將「時間印跡」與前述帳戶進行綁定，並確保餘額充足。因帳戶餘額不足導致續費失敗者，相關結果由您自行承擔。
        </li>
        <li>
          支付後 Pro 未到帳處理方式：若您訂閱並支付後 Pro 服務未及時生效，請先更新至最新版 App，並在 Pro 個人中心頁點擊「恢復購買」以恢復 Pro 權益；若仍未解決，請聯絡我們（郵箱：solovetime@163.com）。
        </li>
      </ol>

      <h2>關於 Apple 的通知</h2>
      <p>
        就您在 iOS 裝置上使用或訪問 時間印跡 而言，您承認並同意本條款僅在您與 時間印跡 之間成立，而非與 Apple Inc.（Apple）之間成立。Apple 不對 時間印跡 及其中任何可用材料承擔責任。
      </p>
      <p>
        Apple 無義務向您提供與 時間印跡 有關的任何維護與支援服務。
      </p>
      <p>
        若 時間印跡 不符合任何適用保證，您可通知 Apple，Apple 將向您退還該行動應用程式之購買價款。在適用法律允許之最大範圍內，Apple 對 時間印跡 不承擔任何其他保固義務；因未遵守任何保固導致之其他索賠、損失、責任、損害、成本或費用，將由我們承擔。
      </p>
      <p>
        Apple 不負責處理您或任何第三方提出之與 時間印跡 或您使用 時間印跡 相關之任何索賠，包括但不限於：（1）產品責任索賠；（2）任何聲稱本行動應用程式不符合適用法律或監管要求之索賠；（3）基於消費者保護或類似立法所生之索賠。
      </p>
      <p>
        Apple 不負責調查、抗辯、和解與免除任何第三方主張本行動應用程式侵犯其智慧財產權之索賠。
      </p>
      <p>
        您同意在使用 時間印跡 時遵守任何適用之第三方條款，包括 Apple App Store 服務協議中規定之任何使用規則。
      </p>
      <p>
        Apple 與其子公司為本服務條款之第三方受益人。您接受本服務條款後，Apple 有權（且視為已接受此權利）作為第三方受益人向您主張並執行本服務條款。
      </p>

      <h2>法律及協議更新</h2>
      <p>
        根據國家法律法規變化及網站營運需要，我們有權不時修改本協議條款，並依法律法規要求進行公示。修改後協議於公示後生效並取代原協議。您應不時關注並閱讀最新版協議及網站公告。如您不同意更新後的新協議，您有權立即停止使用我們的產品和／或服務。若您繼續使用我們的產品和／或服務，即視為完全同意更新後協議。若本協議中任何一條被司法或行政機關認定廢止、無效或因任何理由不可執行，該條款應視為可分，且不影響其餘條款之有效性與可執行性。
      </p>
      <p>
        上述條款受中華人民共和國法律約束並據其解釋。如有爭議，使用者與時間印跡團隊一致同意將爭議提交至當地人民法院管轄。如您對本服務條款有任何疑問，可發送郵件至 <a href="mailto:solovetime@163.com">solovetime@163.com</a> 獲取相關資訊。
      </p>
    `,
  },
  ja: {
    title: '利用規約',
    updated: '最終更新日：2023年5月10日',
    html: `
      <h2>サービス利用規約</h2>
      <p>
        本利用規約は、TimeEcho、当社ウェブサイト（https://lovetime.life）、および当社が提供する関連サービスの利用に適用されます。
      </p>
      <p>
        TimeEcho を利用することにより、利用者は本規約および適用される法令を遵守することに同意したものとみなされます。本規約に同意しない場合、アプリ、当社ウェブサイト、または TimeEcho が提供するその他のサービスを利用することはできません。
      </p>
      <p>
        Apple App Store から TimeEcho にアクセスまたはダウンロードする場合、利用者は App Store の利用規則にも同意するものとします。
      </p>
      <p>
        当社は、独自の裁量により本規約を見直し、変更する権利を留保します。変更は公開時点から直ちに効力を生じます。
      </p>

      <h2>利用制限</h2>
      <p>利用者は、自己、自己が代表する法人、および自己のユーザーを代表して、以下の行為を行わないことを保証します。</p>
      <ol>
        <li>TimeEcho または当社サイト上の資料・ソフトウェアを改変、複製、派生物作成、逆コンパイル、リバースエンジニアリングすること。</li>
        <li>TimeEcho または当社サイト上の資料・ソフトウェアから著作権表示その他の権利表示を削除すること。</li>
        <li>TimeEcho または関連資料を第三者へ移転すること、または他サーバーへミラーリングすること。</li>
        <li>当社ネットワークまたは他サービスを乱用・妨害する方法で TimeEcho または関連サービスを意図的または非意図的に利用すること。</li>
        <li>嫌がらせ、わいせつ、詐欺、違法な内容を TimeEcho または関連サービスで送信・公開すること。</li>
        <li>適用法令に違反して TimeEcho または関連サービスを利用すること。</li>
        <li>無断広告やスパム配信のために TimeEcho を利用すること。</li>
        <li>ユーザー同意なくユーザーデータを収集・取得すること。</li>
        <li>第三者のプライバシー権、知的財産権、その他の権利を侵害する方法で TimeEcho または関連サービスを利用すること。</li>
      </ol>

      <h2>知的財産権</h2>
      <p>
        当社ウェブサイト上の資料に関する知的財産権は TimeEcho およびその創業チームに帰属します。利用者は個人的利用に限り、TimeEcho をダウンロードし、モバイル端末上で閲覧・使用・表示できます。
      </p>
      <p>
        これは所有権移転ではなく、ライセンス付与です。利用者が本規約または制限に違反した場合、当該ライセンスは自動的に終了し、TimeEcho はいつでも終了させることができます。
      </p>

      <h2>自動更新</h2>
      <p>
        利用者は、プライバシー設定に従って当社が利用者端末に TimeEcho の更新をダウンロード・インストールすることを許可します。端末から TimeEcho を削除することで、この許可はいつでも撤回できます。
      </p>

      <h2>責任</h2>
      <p>
        TimeEcho および当社サイト上の資料は「現状有姿」で提供されます。法令で認められる最大範囲で、当社は明示または黙示の保証を行わず、商品性、特定目的適合性、非侵害等を含むあらゆる保証を否認します。
      </p>
      <p>
        利用者または第三者が TimeEcho、当社ウェブサイト、関連サービス、または TimeEcho 内資料の利用・利用不能により被った間接損害について、当社または供給者は一切責任を負いません。損害発生可能性を口頭または書面で通知されていた場合も同様です。
      </p>
      <p>
        本規約における「間接損害」には、逸失利益（実際または予想）、利益・収益・事業・信用・機会・節約・評判・使用の喪失、データの喪失・毀損などが含まれ、法令、契約、衡平法、不法行為（過失を含む）、補償その他の根拠を問いません。
      </p>
      <p>
        一部の法域では黙示保証の制限や付随的・間接的損害に対する責任制限が認められないため、これらの制限が適用されない場合があります。
      </p>

      <h2>Pro サブスクリプション契約</h2>
      <ol>
        <li>
          有料の Pro サブスクリプション開始後、対象期間中は TimeEcho の Pro 機能を継続して利用できます。（注：サブスクリプションは Apple ID と強く紐づきます。利用中に Apple ID を切り替えるとデータ不整合が生じる可能性があり、利用者ご自身の責任となります。）
        </li>
        <li>
          月額自動更新・年額自動更新は、Pro 有効化を前提とする自動更新サービスです。これらを有効化すると、現在期間満了前 24 時間以内に、利用者の各種支払いアカウント（残高口座、TimeEcho と連携した第三者決済口座、銀行カード、通信アカウント、iTunes アカウント等）から次期料金を自動徴収することに同意したものとみなされます。アカウント連携および残高確保は利用者の責任です。残高不足による更新失敗の結果は利用者が負担します。
        </li>
        <li>
          支払い後に Pro が反映されない場合：最新バージョンへ更新し、Pro センターの「購入を復元」をお試しください。解決しない場合は solovetime@163.com までご連絡ください。
        </li>
      </ol>

      <h2>Apple に関する通知</h2>
      <p>
        iOS デバイスでの TimeEcho の利用に関して、利用者は本規約が利用者と TimeEcho の間でのみ締結され、Apple Inc.（Apple）との間ではないことを認めます。Apple は TimeEcho およびその提供物に責任を負いません。
      </p>
      <p>Apple は TimeEcho に関する保守・サポートサービスを提供する義務を負いません。</p>
      <p>
        TimeEcho が適用保証に適合しない場合、利用者は Apple へ通知でき、Apple は購入金額を返金する場合があります。適用法で認められる最大範囲において、Apple はそれ以外の保証責任を負わず、保証不適合に起因するその他の請求・損失・損害・費用は当社が負担します。
      </p>
      <p>
        Apple は、TimeEcho または利用者による利用に関連する利用者または第三者からの請求（製造物責任、法令適合性、消費者保護法等に基づく請求を含む）に対応する責任を負いません。
      </p>
      <p>
        Apple は、当社アプリが第三者知的財産権を侵害するとする請求の調査・防御・和解・解決責任を負いません。
      </p>
      <p>
        利用者は TimeEcho 利用時、Apple App Store 規約に定める利用規則を含む第三者規約を遵守することに同意します。
      </p>
      <p>
        Apple およびその子会社は本規約の第三者受益者であり、利用者が本規約に同意した時点で、Apple は第三者受益者として本規約を利用者に対して行使する権利を有します。
      </p>

      <h2>準拠法および規約更新</h2>
      <p>
        法令変更または運営上の必要に応じ、当社は本規約を随時変更し、必要に応じて公示します。更新規約は公示後に効力を生じ、旧規約に優先します。利用者は最新規約および告知を適宜確認してください。更新規約に同意しない場合、利用者は直ちに当社製品・サービスの利用を停止できます。利用継続は更新規約への同意とみなされます。本規約の一部が無効または執行不能と判断された場合でも、他の条項の有効性・執行可能性には影響しません。
      </p>
      <p>
        本規約は中華人民共和国法に準拠し、これに従って解釈されます。紛争が生じた場合、利用者と TimeEcho チームは、現地の人民法院を専属管轄とすることに同意します。本規約に関するご質問は <a href="mailto:solovetime@163.com">solovetime@163.com</a> までご連絡ください。
      </p>
    `,
  },
  ko: {
    title: '이용약관',
    updated: '최근 업데이트: 2023년 5월 10일',
    html: `
      <h2>서비스 약관</h2>
      <p>
        본 약관은 TimeEcho, 당사 웹사이트(https://lovetime.life), 그리고 당사가 제공하는 관련 서비스의 이용에 적용됩니다.
      </p>
      <p>
        TimeEcho를 이용함으로써 귀하는 본 약관과 적용되는 모든 법률 및 규정을 준수하는 데 동의합니다. 본 약관에 동의하지 않는 경우, 앱 사용, 웹사이트 접속 및 TimeEcho가 제공하는 기타 서비스 이용이 제한됩니다.
      </p>
      <p>
        Apple App Store를 통해 TimeEcho를 다운로드하거나 접근하는 경우, App Store 서비스 약관의 사용 규칙에도 동의한 것으로 간주됩니다.
      </p>
      <p>
        당사는 단독 재량으로 본 약관을 검토 및 수정할 권리를 보유하며, 변경 사항은 게시 즉시 효력이 발생합니다.
      </p>

      <h2>사용 제한</h2>
      <p>귀하는 본인, 귀하가 대표하는 법인, 그리고 귀하의 사용자들을 대표하여 다음 행위를 하지 않을 것을 보증합니다.</p>
      <ol>
        <li>TimeEcho 또는 당사 웹사이트에 포함된 자료/소프트웨어를 수정, 복제, 파생물 작성, 디컴파일, 리버스 엔지니어링하는 행위</li>
        <li>TimeEcho 또는 당사 웹사이트의 자료/소프트웨어에서 저작권 또는 기타 권리표시를 제거하는 행위</li>
        <li>TimeEcho 또는 관련 자료를 제3자에게 이전하거나 다른 서버에 미러링하는 행위</li>
        <li>당사 네트워크 또는 기타 서비스를 남용·방해하는 방식으로 TimeEcho 또는 관련 서비스를 고의 또는 과실로 사용하는 행위</li>
        <li>괴롭힘, 외설, 사기, 불법 자료를 TimeEcho 또는 관련 서비스로 전송·게시하는 행위</li>
        <li>적용 법령을 위반하여 TimeEcho 또는 관련 서비스를 사용하는 행위</li>
        <li>무단 광고 또는 스팸 발송을 위해 TimeEcho를 사용하는 행위</li>
        <li>사용자 동의 없이 사용자 데이터를 수집·취합하는 행위</li>
        <li>제3자의 개인정보권, 지식재산권 또는 기타 권리를 침해할 수 있는 방식으로 TimeEcho 또는 관련 서비스를 사용하는 행위</li>
      </ol>

      <h2>지식재산권</h2>
      <p>
        당사 웹사이트 자료에 대한 지식재산권은 TimeEcho 및 창립팀에 귀속됩니다. 귀하는 개인적 용도에 한해 TimeEcho를 다운로드하고 모바일 기기에서 열람·사용·표시할 수 있습니다.
      </p>
      <p>
        이는 소유권 이전이 아닌 라이선스 부여입니다. 귀하가 본 제한 또는 약관을 위반하는 경우 라이선스는 자동 종료되며, TimeEcho는 언제든 이를 종료할 수 있습니다.
      </p>

      <h2>자동 업데이트</h2>
      <p>
        귀하는 개인정보 설정에 따라 당사가 귀하의 기기에 TimeEcho 업데이트를 다운로드·설치하는 것을 허용합니다. TimeEcho를 삭제하면 언제든 해당 권한을 철회할 수 있습니다.
      </p>

      <h2>책임</h2>
      <p>
        TimeEcho 및 당사 웹사이트의 자료는 “있는 그대로” 제공됩니다. 법이 허용하는 최대 범위에서 명시적·묵시적 보증을 제공하지 않으며, 상품성, 특정 목적 적합성, 비침해성 등을 포함한 모든 보증을 부인합니다.
      </p>
      <p>
        TimeEcho, 당사 웹사이트, 기타 제공 서비스 또는 TimeEcho 내 자료의 사용 또는 사용 불가로 인해 발생한 간접손해에 대해, 그 가능성을 사전에 통지받은 경우에도 TimeEcho 팀 및 공급업체는 책임을 지지 않습니다.
      </p>
      <p>
        본 약관에서 “간접손해”에는 간접적 손해, 실제/예상 이익 손실, 이익·매출·사업·영업권·기회·절감·명성·사용의 손실, 데이터 손실·훼손 등이 포함되며, 법령·계약·형평·불법행위(과실 포함)·보상 등 법적 근거와 무관합니다.
      </p>
      <p>
        일부 관할권에서는 묵시적 보증 제한 또는 부수적·간접적 손해에 대한 책임 제한을 허용하지 않을 수 있으며, 이 경우 해당 제한이 적용되지 않을 수 있습니다.
      </p>

      <h2>Pro 구독 약정</h2>
      <ol>
        <li>
          유료 Pro 구독을 활성화하면 해당 서비스 기간 동안 TimeEcho의 Pro 기능 전체에 지속적으로 접근할 수 있습니다. (참고: 구독은 Apple ID와 강하게 연결됩니다. 앱 사용 중 Apple ID를 변경하면 데이터 오류가 발생할 수 있으며, 이에 대한 책임은 사용자에게 있습니다.)
        </li>
        <li>
          월간/연간 자동갱신은 Pro 구독 활성화 이후 제공되는 자동결제 서비스입니다. 해당 서비스를 활성화하면, 현재 결제 주기 만료 전 24시간 이내에 다음 결제 주기 요금이 귀하의 계정(충전 계정, TimeEcho에 연결된 제3자 결제 계정, 은행카드, 통신 계정, iTunes 계정 등)에서 자동으로 청구되도록 승인한 것으로 봅니다. 관련 계정 연결 및 충분한 잔액 유지는 사용자 책임이며, 잔액 부족으로 갱신 실패 시 그 결과는 사용자 부담입니다.
        </li>
        <li>
          결제 후 Pro가 적용되지 않을 경우: 앱을 최신 버전으로 업데이트한 뒤 Pro 개인센터에서 “구매 복원”을 눌러 주세요. 그래도 해결되지 않으면 solovetime@163.com 으로 문의해 주세요.
        </li>
      </ol>

      <h2>Apple 관련 고지</h2>
      <p>
        iOS 기기에서 TimeEcho를 이용하는 경우, 본 약관은 사용자와 TimeEcho 사이에만 적용되며 Apple Inc.(Apple)와는 별개임을 인정합니다. Apple은 TimeEcho 및 앱 내 자료에 대해 책임을 지지 않습니다.
      </p>
      <p>
        Apple은 TimeEcho와 관련한 유지보수 및 지원 서비스를 제공할 의무가 없습니다.
      </p>
      <p>
        TimeEcho가 적용 가능한 보증을 충족하지 못하는 경우, 사용자는 Apple에 통지할 수 있으며 Apple은 앱 구매금액을 환불할 수 있습니다. 관련 법령이 허용하는 최대 범위에서 Apple은 그 외 보증 책임을 지지 않으며, 보증 불이행으로 인한 기타 청구·손해·비용은 당사가 부담합니다.
      </p>
      <p>
        Apple은 TimeEcho 또는 TimeEcho 사용과 관련하여 사용자 또는 제3자가 제기하는 어떠한 청구(제조물 책임, 법규 준수, 소비자보호 관련 청구 포함)에 대해서도 처리 책임을 지지 않습니다.
      </p>
      <p>
        Apple은 당사 앱이 제3자의 지식재산권을 침해한다는 주장에 대한 조사, 방어, 합의, 해결 책임을 지지 않습니다.
      </p>
      <p>
        귀하는 TimeEcho 이용 시 Apple App Store 서비스 약관의 사용 규칙을 포함하여 적용 가능한 제3자 약관을 준수하는 데 동의합니다.
      </p>
      <p>
        Apple 및 Apple의 자회사는 본 약관의 제3자 수익자이며, 귀하가 본 약관을 수락하면 Apple은 제3자 수익자로서 본 약관을 귀하에게 집행할 권리를 가집니다.
      </p>

      <h2>준거법 및 약관 업데이트</h2>
      <p>
        법령 변경 및 서비스 운영 필요에 따라 당사는 본 약관을 수시로 수정할 수 있으며, 관련 법령 요구에 따라 공지합니다. 수정된 약관은 공지 후 효력이 발생하여 기존 약관을 대체합니다. 사용자는 최신 약관 및 공지를 수시로 확인해야 합니다. 수정 약관에 동의하지 않는 경우 즉시 서비스 이용을 중단할 수 있습니다. 계속 이용할 경우 수정 약관에 동의한 것으로 간주됩니다. 본 약관의 일부 조항이 무효 또는 집행 불가능하다고 판단되더라도, 나머지 조항의 유효성과 집행 가능성에는 영향을 주지 않습니다.
      </p>
      <p>
        본 약관은 중화인민공화국 법률의 적용을 받으며 그에 따라 해석됩니다. 분쟁 발생 시 사용자와 TimeEcho 팀은 현지 인민법원의 관할에 따르기로 합의합니다. 본 약관 관련 문의는 <a href="mailto:solovetime@163.com">solovetime@163.com</a> 으로 연락해 주세요.
      </p>
    `,
  },
  fr: {
    title: "Conditions d'utilisation",
    updated: 'Dernière mise à jour : 10 mai 2023',
    html: `
      <h2>Conditions du service</h2>
      <p>
        Les présentes conditions s’appliquent à votre utilisation de TimeEcho, de notre site web https://lovetime.life et de tout service connexe que nous fournissons.
      </p>
      <p>
        En utilisant TimeEcho, vous acceptez de respecter ces conditions ainsi que l’ensemble des lois et réglementations applicables. Si vous n’acceptez pas ces conditions, vous n’êtes pas autorisé à continuer d’utiliser l’application, notre site web ou tout autre service fourni par TimeEcho.
      </p>
      <p>
        Si vous accédez à TimeEcho ou le téléchargez depuis l’Apple App Store, vous acceptez également les règles d’utilisation prévues par les conditions de l’App Store.
      </p>
      <p>
        Nous nous réservons le droit de réviser et de modifier ces conditions à tout moment, à notre seule discrétion. Toute modification prend effet immédiatement à compter de sa publication.
      </p>

      <h2>Restrictions d’utilisation</h2>
      <p>En utilisant TimeEcho et notre site web, vous garantissez, en votre nom, au nom de toute entité que vous représentez et de vos utilisateurs, que vous ne :</p>
      <ol>
        <li>modifierez, copierez, préparerez des œuvres dérivées, décompilerez ou ferez de l’ingénierie inverse de TimeEcho ou des logiciels et contenus figurant dans TimeEcho ou sur notre site ;</li>
        <li>supprimerez aucune mention de droit d’auteur ou autre mention de propriété sur les contenus et logiciels de TimeEcho ou de notre site ;</li>
        <li>transférerez TimeEcho ou ses contenus associés à une autre personne, ni ne les « miroirez » sur un autre serveur ;</li>
        <li>utiliserez TimeEcho ou ses services associés de manière intentionnelle ou non, dans un but d’abus ou de perturbation de notre réseau ou de tout autre service ;</li>
        <li>utiliserez TimeEcho ou ses services associés pour transmettre ou publier des contenus harcelants, obscènes, frauduleux ou illégaux ;</li>
        <li>utiliserez TimeEcho ou ses services associés en violation de la loi applicable ;</li>
        <li>utiliserez TimeEcho pour envoyer des publicités non autorisées ou du spam ;</li>
        <li>collecterez des données utilisateur sans consentement ;</li>
        <li>utiliserez TimeEcho ou ses services associés d’une manière susceptible de porter atteinte aux droits à la vie privée, aux droits de propriété intellectuelle ou à tout autre droit d’un tiers.</li>
      </ol>

      <h2>Propriété intellectuelle</h2>
      <p>
        Les droits de propriété intellectuelle sur les contenus de notre site appartiennent à TimeEcho et à son équipe fondatrice. Vous pouvez télécharger TimeEcho et l’afficher/utiliser sur votre appareil mobile uniquement à des fins personnelles.
      </p>
      <p>
        Il s’agit d’une licence d’utilisation, non d’un transfert de propriété. Cette licence prend automatiquement fin en cas de violation des présentes conditions, et TimeEcho peut y mettre fin à tout moment.
      </p>

      <h2>Mises à jour automatiques</h2>
      <p>
        Vous nous autorisez à télécharger et installer des mises à jour de TimeEcho sur votre appareil selon vos préférences de confidentialité. Cette autorisation peut être retirée à tout moment en supprimant TimeEcho de votre appareil.
      </p>

      <h2>Responsabilité</h2>
      <p>
        TimeEcho et les contenus de notre site sont fournis « en l’état ». Dans les limites autorisées par la loi, nous excluons toute garantie expresse ou implicite, y compris notamment les garanties de qualité marchande, d’adéquation à un usage particulier, de non-contrefaçon, ou de non-atteinte à des droits.
      </p>
      <p>
        En aucun cas l’équipe TimeEcho ou ses fournisseurs ne pourront être tenus responsables des pertes indirectes subies par vous ou un tiers du fait de l’utilisation ou de l’impossibilité d’utiliser TimeEcho, notre site, tout autre service fourni, ou les contenus de TimeEcho, même en cas d’information préalable sur la possibilité de tels dommages.
      </p>
      <p>
        Au sens des présentes, « pertes indirectes » inclut notamment les pertes de profits (réels ou anticipés), d’avantages, de revenus, d’activité, de clientèle, d’opportunités, d’économies, de réputation, de jouissance, et/ou la perte ou corruption de données, quel qu’en soit le fondement juridique (légal, contractuel, quasi-délictuel, négligence, indemnisation, etc.).
      </p>
      <p>
        Certaines juridictions n’autorisant pas la limitation des garanties implicites ou de la responsabilité pour dommages indirects, ces limitations peuvent ne pas s’appliquer à vous.
      </p>

      <h2>Accord d’abonnement Pro</h2>
      <ol>
        <li>
          Après activation d’un abonnement Pro payant, vous pouvez accéder à toutes les fonctionnalités Pro de TimeEcho pendant la durée concernée. (Remarque : l’abonnement est fortement lié à l’Apple ID. Changer d’Apple ID pendant l’utilisation peut provoquer des erreurs de données, dont vous assumez la responsabilité.)
        </li>
        <li>
          Les offres mensuelles et annuelles reconduites automatiquement sont des services de renouvellement auto fournis après activation de Pro. En activant l’une de ces offres, vous autorisez TimeEcho à prélever les frais du cycle suivant sur vos comptes de paiement (compte prépayé, compte tiers lié à TimeEcho, carte bancaire, compte opérateur, compte iTunes, etc.) dans les 24 heures précédant l’expiration. Vous devez lier les comptes concernés et vous assurer d’un solde suffisant. En cas d’échec du renouvellement faute de solde, vous en assumez les conséquences.
        </li>
        <li>
          Si Pro n’est pas activé après paiement : mettez l’application à jour vers la dernière version, puis cliquez sur « Restaurer les achats » dans le centre Pro. Si le problème persiste, contactez-nous à solovetime@163.com.
        </li>
      </ol>

      <h2>Notification relative à Apple</h2>
      <p>
        Concernant l’utilisation de TimeEcho sur iOS, vous reconnaissez que les présentes conditions sont conclues entre vous et TimeEcho uniquement, et non avec Apple Inc. (« Apple »). Apple n’est pas responsable de TimeEcho ni des contenus qui y sont disponibles.
      </p>
      <p>Apple n’a aucune obligation de maintenance ou d’assistance concernant TimeEcho.</p>
      <p>
        Si TimeEcho ne respecte pas une garantie applicable, vous pouvez en informer Apple, qui pourra vous rembourser le prix d’achat de l’application mobile. Dans la limite maximale autorisée par la loi, Apple n’assume aucune autre obligation de garantie, et toute autre réclamation, perte, responsabilité, dommage, coût ou dépense liée à ce défaut de conformité relève de notre responsabilité.
      </p>
      <p>
        Apple n’est pas responsable du traitement des réclamations formulées par vous ou un tiers concernant TimeEcho ou son utilisation, y compris notamment : (1) les réclamations de responsabilité produit ; (2) les réclamations relatives au non-respect de dispositions légales ou réglementaires applicables ; (3) les réclamations fondées sur la protection des consommateurs ou textes similaires.
      </p>
      <p>
        Apple n’est pas responsable de l’enquête, de la défense, du règlement ou de la mainlevée de toute réclamation d’un tiers selon laquelle notre application mobile violerait ses droits de propriété intellectuelle.
      </p>
      <p>
        Vous acceptez de respecter toute condition de tiers applicable lors de l’utilisation de TimeEcho, y compris les règles d’utilisation de l’Apple App Store.
      </p>
      <p>
        Apple et ses filiales sont des tiers bénéficiaires des présentes conditions. Après votre acceptation, Apple aura le droit (et sera réputée avoir accepté ce droit) de faire valoir ces conditions contre vous en qualité de tiers bénéficiaire.
      </p>

      <h2>Droit applicable et mises à jour du contrat</h2>
      <p>
        En fonction des évolutions légales/réglementaires et des besoins d’exploitation, nous pouvons modifier les présentes conditions et les publier conformément aux exigences légales. Les conditions mises à jour prennent effet après publication et remplacent les versions antérieures. Vous devez consulter régulièrement la dernière version des conditions et les annonces du site. Si vous n’acceptez pas les nouvelles conditions, vous pouvez cesser immédiatement d’utiliser nos produits et/ou services. La poursuite de l’utilisation vaut acceptation pleine et entière. Si une clause est déclarée nulle, invalide ou inapplicable, elle sera dissociable et n’affectera pas la validité ni l’applicabilité des autres clauses.
      </p>
      <p>
        Les présentes conditions sont régies et interprétées conformément au droit de la République populaire de Chine. En cas de litige, l’utilisateur et l’équipe TimeEcho conviennent de soumettre le litige au tribunal populaire local compétent. Pour toute question sur ces conditions, veuillez écrire à <a href="mailto:solovetime@163.com">solovetime@163.com</a>.
      </p>
    `,
  },
};

export const privacyPolicyContent = {
  en: {
    title: 'Privacy Policy',
    updated: 'Last updated: May 10, 2023',
    html: `
      <p>
        Welcome to TimeEcho. TimeEcho is a time-tracking app inspired by the Lyubishchev time management method, designed to help users focus on the present, separate work from life, and build long-term discipline.
      </p>
      <p>
        This Privacy Policy explains how we and some of our partners collect, use, share, and protect information related to our mobile services, website, software provided on or in connection with TimeEcho services (collectively, the “Services”), and the choices you make regarding your information.
      </p>
      <p>
        By using our Services, you understand and agree that we provide software tools for timers and records through relevant Services.
      </p>

      <h2>Information We Collect</h2>
      <h3>Information You Provide Directly</h3>

      <h3>Analytics Information</h3>
      <p>
        We use third-party analytics tools to help us measure traffic and usage trends for the Services. These tools collect information sent by your device or our Services, including pages you visit, add-ons, and other information that helps us improve the Services. We use this information together with analytics information from other users so it cannot reasonably be used to identify any specific individual user.
      </p>

      <h3>Device Identifiers</h3>
      <p>
        When you access the Services with a mobile device (such as a tablet or phone), we may access, collect, monitor, store, and/or remotely store one or more device identifiers on your device. Device identifiers are small data files or similar structures stored on or associated with your mobile device and used to uniquely identify your device. A device identifier may be data stored in connection with device hardware, operating system data, software data, or data sent to the device by LATTE.
      </p>
      <p>
        Device identifiers may provide us or third-party partners with information about how you browse and use the Services and help us or others provide reports or personalized content and advertising. If the use or availability of device identifiers is impaired or disabled, some features of the Services may not function properly.
      </p>

      <h2>How We Use Your Information</h2>
      <p>In addition to specific uses described in this Privacy Policy, we may use received information to:</p>
      <ul>
        <li>develop and test new products and features;</li>
        <li>diagnose or resolve technical issues.</li>
      </ul>

      <h2>How We Share Your Information</h2>
      <p>
        Except as stated in this Policy, we will not lend or sell your information to third parties outside TimeEcho (or TimeEcho’s affiliated group companies) without your consent.
      </p>
      <p>
        We may share your information with third-party organizations that help us provide Services (“Service Providers”), including information and data from tools such as cookies, log files, device identifiers, and location data. Our Service Providers are permitted to access your information only as reasonably necessary to provide Services, and subject to appropriate confidentiality obligations.
      </p>
      <p>
        We may also share certain information such as cookie data with third-party advertising partners. This information allows third-party ad networks to provide targeted ads and related services that they believe are most relevant to you.
      </p>
      <p>
        We may remove identifying parts of your data and share anonymized data with others. We may also combine your information with other information in a way that no longer associates it with you and share such aggregated information.
      </p>

      <h2>Other Websites and Services</h2>
      <p>
        We are not responsible for the practices of any websites or services linked to or from our Services, including information or content provided by those websites or services. Please remember that when you use links to navigate from our Services to another website or service, this Privacy Policy does not apply to those third-party websites or services. Your browsing and interaction on third-party websites or services are governed by that third party’s own rules and policies. You also agree that we are not responsible for, and have no control over, any third party you authorize to access your user content. If you use a third-party website or service and allow it to access your user content, you do so at your own risk.
      </p>

      <h2>How to Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or the Services, please contact us at <a href="mailto:solovetime@163.com">solovetime@163.com</a>.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        TimeEcho may modify or update this Privacy Policy from time to time. Please review it periodically. We may provide additional forms of notice of updates where appropriate. Your continued use of TimeEcho or the Services after any change to this Privacy Policy indicates your acceptance of those changes.
      </p>
    `,
  },
  'zh-Hans': {
    title: '隐私政策',
    updated: '最近更新：2023年5月10日',
    html: `
      <p>
        欢迎使用 时间印迹。时间印迹 是一款基于柳比歇夫时间法的一款时间追踪软件，帮助用户更好的专注当下、区分工作与生活、成为一个长期主义者。
      </p>
      <p>
        对于我们和我们的部分合作企业，就收集、使用、分享和保护与我们的移动服务、网站、在 时间印迹 上提供或与 时间印迹 服务（以下统称“服务”）有关的任何软件，以及您对于收集和使用您的信息所作出的选择等内容，我们的“隐私政策”作出了解释。
      </p>
      <p>
        使用我们的“服务”即表示您理解并同意，我们只是为您提供通过相关“服务”提供计时器和记录的软件。
      </p>

      <h2>我们收集的信息</h2>
      <h3>您向我们直接提供的信息</h3>

      <h3>分析信息</h3>
      <p>
        我们使用第三方分析工具帮助我们测量“服务”的流量和使用趋势。这些工具收集通过您的设备或我们的“服务”发送的信息，包括您访问的网页、附加组件和帮助我们改善“服务”的其它信息。我们收集此信息并与从其他用户收集的分析信息同时使用，使此信息不致被用于识别任何具体个人用户。
      </p>

      <h3>设备标识符</h3>
      <p>
        当您使用移动设备（如平板电脑或手机）访问我们的“服务”时，我们可能在您的设备上执行访问、收集、监控、存储操作，和/或远程存储一个或多个“设备标识符”。设备标识符是在您的移动设备上存储或与之相关联的小数据文件或类似数据结构，用作您的移动设备的唯一标识。设备标识符可能是与设备硬件相关的存储数据、与设备操作系统或其它软件相关的存储数据或 LATTE 发送到设备的数据。
      </p>
      <p>
        设备标识符可以向我们或第三方合作伙伴提供有关您如何浏览和使用“服务”的信息并帮助我们或他方提供报告或个性化内容和广告。如果设备标识符的使用或可用性受损或被禁用，“服务”的某些功能可能无法正常工作。
      </p>

      <h2>我们如何使用您的信息</h2>
      <p>除了我们在本“隐私政策”中描述的某些具体信息使用方法，我们还可将收到的信息用于：</p>
      <ul>
        <li>开发和测试新产品和功能。</li>
        <li>诊断或解决技术问题。</li>
      </ul>

      <h2>分享您的信息</h2>
      <p>
        除非本“政策”说明，否则，未经您同意，我们不会向 时间印迹（或 时间印迹 所属公司集团）之外的第三方出借或出售您的信息。
      </p>
      <p>
        我们可能分享您信息的各方：我们还可与帮助我们为您提供“服务”的第三方组织（以下简称“服务提供商”）分享您的信息以及诸如 cookie 等工具的信息、日志文件、设备标识符和位置数据。我们的“服务提供商”将有权在必要情况下访问您的信息，并依据合理的保密条款提供“服务”。
      </p>
      <p>
        我们还可能与第三方广告合作伙伴分享某些诸如 cookie 数据之类的信息。此信息将允许第三方广告网络提供其认为您最感兴趣的有针对性的广告等。
      </p>
      <p>
        我们会删除能够识别您身份的部分数据并与他方分享匿名数据。我们还可用与您不再有关联的方式将您的信息与其它信息进行组合并分享该汇总信息。
      </p>

      <h2>其它网站和服务</h2>
      <p>
        我们对与我们的“服务”存在链接关系的任何网站或服务所从事的行为，包括相关网站和服务所提供的信息或内容，不承担责任。请切记，当您使用链接从我们的“服务”进入其它网站或服务时，我们的“隐私政策”不适用于这些第三方网站或服务。您在任何第三方网站或服务上（包括在我们的网站上有链接的第三方网站或服务）采取的浏览和互动行为受该第三方的规则和政策约束。此外，您同意对您授权访问您“用户内容”的任何第三方，我们不承担责任，且没有控制权。如果您正在使用第三方网站或服务，并且允许其访问您的“用户内容”，风险自行承担。
      </p>

      <h2>如何联系我们</h2>
      <p>
        如果对本“隐私政策”或“服务”有任何疑问，请与我们联系（邮箱：<a href="mailto:solovetime@163.com">solovetime@163.com</a>）。
      </p>

      <h2>关于我们的“隐私政策”的更改</h2>
      <p>
        时间印迹 可能不定期修改或更新本“隐私政策”，请定期查阅。我们可能在适当环境下为您提供其它形式的修改或更新声明。在本“隐私政策”做出任何修改后，您继续使用 时间印迹 或“服务”即表示您接受此类修改。
      </p>
    `,
  },
  'zh-Hant': {
    title: '隱私政策',
    updated: '最近更新：2023年5月10日',
    html: `
      <p>
        歡迎使用 時間印跡。時間印跡 是一款基於柳比歇夫時間法的時間追蹤軟體，幫助使用者更好地專注當下、區分工作與生活，成為長期主義者。
      </p>
      <p>
        對於我們以及部分合作夥伴就蒐集、使用、分享與保護和我們的行動服務、網站、在 時間印跡 上提供或與 時間印跡 服務（以下統稱「服務」）相關之資訊，以及您對資訊蒐集與使用所作出的選擇，本「隱私政策」將作出說明。
      </p>
      <p>
        使用我們的「服務」即表示您理解並同意：我們僅透過相關「服務」為您提供計時器與記錄功能軟體。
      </p>

      <h2>我們蒐集的資訊</h2>
      <h3>您直接提供給我們的資訊</h3>

      <h3>分析資訊</h3>
      <p>
        我們使用第三方分析工具協助衡量「服務」的流量與使用趨勢。這些工具會蒐集由您的裝置或我們「服務」發送之資訊，包括您訪問的頁面、附加元件及其他有助於改善「服務」的資訊。我們會將該資訊與其他使用者的分析資訊共同使用，以避免用於識別特定個人。
      </p>

      <h3>裝置識別碼</h3>
      <p>
        當您使用行動裝置（如平板或手機）訪問我們的「服務」時，我們可能在您的裝置上執行訪問、蒐集、監控、儲存，及／或遠端儲存一個或多個「裝置識別碼」。裝置識別碼是儲存在您的行動裝置上或與之關聯的小型資料檔案或類似資料結構，用於唯一識別您的裝置。裝置識別碼可能是與硬體相關的儲存資料、與作業系統或其他軟體相關的儲存資料，或由 LATTE 發送到裝置的資料。
      </p>
      <p>
        裝置識別碼可向我們或第三方合作夥伴提供您如何瀏覽與使用「服務」的資訊，並幫助我們或第三方提供報告或個人化內容與廣告。若裝置識別碼的使用或可用性受損或停用，「服務」部分功能可能無法正常運作。
      </p>

      <h2>我們如何使用您的資訊</h2>
      <p>除本「隱私政策」中載明的特定用途外，我們還可能將所收資訊用於：</p>
      <ul>
        <li>開發與測試新產品和功能；</li>
        <li>診斷或解決技術問題。</li>
      </ul>

      <h2>分享您的資訊</h2>
      <p>
        除本「政策」說明外，未經您同意，我們不會向 時間印跡（或其所屬公司集團）以外第三方出借或出售您的資訊。
      </p>
      <p>
        我們可能與協助提供「服務」之第三方機構（以下稱「服務提供商」）分享您的資訊，以及 cookie 等工具資訊、日誌檔、裝置識別碼與位置資料。我們的「服務提供商」僅可在必要範圍內訪問您的資訊，並應遵守合理保密義務。
      </p>
      <p>
        我們亦可能與第三方廣告合作夥伴分享某些資訊（如 cookie 資料）。該資訊可使第三方廣告網路提供其認為與您最相關的定向廣告等服務。
      </p>
      <p>
        我們會刪除可識別您身份的部分資料，並與他方分享匿名資料。我們也可能以不再與您直接關聯之方式，將您的資訊與其他資訊組合後分享匯總資訊。
      </p>

      <h2>其他網站與服務</h2>
      <p>
        對於與我們「服務」存在連結關係的任何網站或服務所採取的行為（包括其提供的資訊或內容），我們不承擔責任。請注意，當您透過我們「服務」中的連結進入其他網站或服務時，本「隱私政策」不適用於該等第三方網站或服務。您在任何第三方網站或服務上的瀏覽與互動行為，受該第三方之規則與政策約束。此外，對於您授權其訪問您「使用者內容」的第三方，我們不承擔責任且不具控制權。若您使用第三方網站或服務並允許其訪問您的「使用者內容」，風險由您自行承擔。
      </p>

      <h2>如何聯絡我們</h2>
      <p>
        如對本「隱私政策」或「服務」有任何疑問，請聯絡我們（郵箱：<a href="mailto:solovetime@163.com">solovetime@163.com</a>）。
      </p>

      <h2>關於本「隱私政策」的變更</h2>
      <p>
        時間印跡 可能不定期修改或更新本「隱私政策」，請定期查閱。我們可能在適當情況下以其他形式向您提供修改或更新聲明。在本「隱私政策」作出任何修改後，您繼續使用 時間印跡 或「服務」即表示您接受該等修改。
      </p>
    `,
  },
  ja: {
    title: 'プライバシーポリシー',
    updated: '最終更新日：2023年5月10日',
    html: `
      <p>
        TimeEcho をご利用いただきありがとうございます。TimeEcho は、リュビシェフ式時間管理法に着想を得た時間追跡アプリであり、現在への集中、仕事と生活の切り分け、長期的な自己成長を支援します。
      </p>
      <p>
        本プライバシーポリシーでは、当社および当社の一部パートナーが、モバイルサービス、ウェブサイト、TimeEcho 上または TimeEcho サービスに関連して提供されるソフトウェア（以下総称して「サービス」）に関して、情報をどのように収集・利用・共有・保護するか、および利用者が行う選択について説明します。
      </p>
      <p>
        当社の「サービス」を利用することで、当社が主として計時と記録機能を提供するソフトウェアであることを理解し、同意したものとみなされます。
      </p>

      <h2>当社が収集する情報</h2>
      <h3>利用者が直接提供する情報</h3>

      <h3>分析情報</h3>
      <p>
        当社は、サービスのトラフィックと利用傾向を測定するために第三者分析ツールを使用します。これらのツールは、利用者のデバイスまたは当社サービスから送信される情報（閲覧ページ、アドオン、その他サービス改善に役立つ情報）を収集します。当社は他ユーザーから収集した分析情報と合わせて利用し、特定個人を識別しない形で活用します。
      </p>

      <h3>デバイス識別子</h3>
      <p>
        利用者がタブレットやスマートフォンなどのモバイル端末でサービスにアクセスする際、当社は当該端末上で 1 つ以上の「デバイス識別子」にアクセス、収集、監視、保存、または遠隔保存する場合があります。デバイス識別子とは、端末に保存される小さなデータファイルまたは類似構造で、端末を一意に識別するために使用されます。ハードウェア関連データ、OS/ソフトウェア関連データ、または LATTE から端末に送信されるデータが含まれる場合があります。
      </p>
      <p>
        デバイス識別子は、サービスの閲覧・利用方法に関する情報を当社または第三者パートナーに提供し、レポートやパーソナライズされたコンテンツ・広告提供に役立ちます。デバイス識別子の利用や可用性が損なわれると、サービスの一部機能が正常に動作しない場合があります。
      </p>

      <h2>情報の利用方法</h2>
      <p>本ポリシーで明示した目的に加えて、当社は収集情報を次の目的で利用する場合があります。</p>
      <ul>
        <li>新製品・新機能の開発およびテスト</li>
        <li>技術的問題の診断および解決</li>
      </ul>

      <h2>情報の共有</h2>
      <p>
        本ポリシーに定める場合を除き、利用者の同意なく、TimeEcho（または TimeEcho の企業グループ）外の第三者に利用者情報を貸与・販売することはありません。
      </p>
      <p>
        当社は、サービス提供を支援する第三者組織（以下「サービス提供者」）に対し、利用者情報、cookie 等のツール情報、ログファイル、デバイス識別子、位置データなどを共有する場合があります。サービス提供者は、合理的な秘密保持条件の下、必要範囲に限って利用者情報へアクセスできます。
      </p>
      <p>
        また、cookie データ等の一部情報を第三者広告パートナーと共有する場合があります。これにより、第三者広告ネットワークは利用者にとって関連性の高いターゲティング広告等を提供できます。
      </p>
      <p>
        当社は、個人を特定可能な要素を削除した匿名データを第三者と共有する場合があります。また、利用者と直接関連付けられない形で他情報と組み合わせ、集計情報として共有する場合があります。
      </p>

      <h2>他のサイトおよびサービス</h2>
      <p>
        当社サービスにリンクされた他のサイトまたはサービスの行為（それらが提供する情報・内容を含む）について、当社は責任を負いません。利用者がリンクを通じて他サイトへ移動した場合、本ポリシーは当該第三者サイト・サービスには適用されません。第三者サイト・サービスでの閲覧・操作は、当該第三者の規則およびポリシーに従います。さらに、利用者が自身のユーザーコンテンツへのアクセスを許可した第三者について、当社は責任を負わず、管理権限も有しません。第三者へのアクセス許可は利用者自身の責任で行ってください。
      </p>

      <h2>お問い合わせ</h2>
      <p>
        本プライバシーポリシーまたはサービスに関するご質問は、<a href="mailto:solovetime@163.com">solovetime@163.com</a> までご連絡ください。
      </p>

      <h2>本プライバシーポリシーの変更</h2>
      <p>
        TimeEcho は本プライバシーポリシーを随時修正または更新することがあります。定期的にご確認ください。必要に応じ、他の形式で更新通知を行う場合があります。本ポリシー変更後も TimeEcho またはサービスを継続利用した場合、当該変更に同意したものとみなされます。
      </p>
    `,
  },
  ko: {
    title: '개인정보 처리방침',
    updated: '최근 업데이트: 2023년 5월 10일',
    html: `
      <p>
        TimeEcho를 이용해 주셔서 감사합니다. TimeEcho는 류비셰프 시간관리법에 기반한 시간 추적 소프트웨어로, 현재에 집중하고 일과 삶을 구분하며 장기적인 성장 습관을 만드는 데 도움을 줍니다.
      </p>
      <p>
        본 개인정보 처리방침은 당사 및 일부 협력사가 모바일 서비스, 웹사이트, TimeEcho 서비스와 관련하여 제공되는 소프트웨어(이하 통칭 “서비스”)와 관련해 정보를 수집·이용·공유·보호하는 방식, 그리고 귀하가 정보 수집 및 이용에 대해 선택할 수 있는 사항을 설명합니다.
      </p>
      <p>
        당사 서비스를 이용하는 것은, 당사가 주로 타이머 및 기록 기능을 제공하는 소프트웨어 서비스를 제공한다는 점을 이해하고 동의함을 의미합니다.
      </p>

      <h2>당사가 수집하는 정보</h2>
      <h3>귀하가 직접 제공하는 정보</h3>

      <h3>분석 정보</h3>
      <p>
        당사는 서비스의 트래픽과 사용 추세를 측정하기 위해 제3자 분석 도구를 사용합니다. 이 도구는 귀하의 기기 또는 서비스에서 전송되는 정보(방문한 페이지, 부가 기능, 서비스 개선에 도움이 되는 기타 정보 포함)를 수집합니다. 당사는 이를 다른 사용자로부터 수집한 분석 정보와 함께 사용하며, 특정 개인을 식별하는 데 사용되지 않도록 처리합니다.
      </p>

      <h3>기기 식별자</h3>
      <p>
        귀하가 태블릿이나 휴대폰 등 모바일 기기로 서비스에 접속할 때, 당사는 귀하의 기기에 하나 이상의 “기기 식별자”를 접근·수집·모니터링·저장하거나 원격 저장할 수 있습니다. 기기 식별자는 모바일 기기에 저장되거나 연동되는 소규모 데이터 파일 또는 유사한 데이터 구조로, 기기를 고유하게 식별하는 데 사용됩니다. 이는 하드웨어 관련 저장 데이터, 운영체제/소프트웨어 관련 저장 데이터 또는 LATTE가 기기로 전송한 데이터일 수 있습니다.
      </p>
      <p>
        기기 식별자는 귀하의 서비스 이용 방식에 대한 정보를 당사 또는 제3자 파트너에 제공하고, 보고서 생성이나 맞춤형 콘텐츠 및 광고 제공에 도움을 줄 수 있습니다. 기기 식별자의 사용 또는 가용성이 제한되거나 비활성화되면 서비스 일부 기능이 정상 작동하지 않을 수 있습니다.
      </p>

      <h2>정보 이용 방법</h2>
      <p>본 처리방침에서 설명한 특정 목적 외에도, 당사는 수집한 정보를 다음 목적으로 사용할 수 있습니다.</p>
      <ul>
        <li>신제품 및 기능 개발·테스트</li>
        <li>기술 문제 진단 및 해결</li>
      </ul>

      <h2>정보 공유</h2>
      <p>
        본 정책에 명시된 경우를 제외하고, 당사는 귀하의 동의 없이 TimeEcho(또는 TimeEcho 소속 기업집단) 외부 제3자에게 귀하의 정보를 대여하거나 판매하지 않습니다.
      </p>
      <p>
        당사는 서비스 제공을 지원하는 제3자 조직(이하 “서비스 제공자”)과 귀하의 정보 및 쿠키 같은 도구 정보, 로그 파일, 기기 식별자, 위치 데이터 등을 공유할 수 있습니다. 서비스 제공자는 필요한 범위 내에서만 귀하 정보에 접근할 수 있으며, 합리적인 비밀유지 의무를 준수해야 합니다.
      </p>
      <p>
        또한 당사는 쿠키 데이터 등 일부 정보를 제3자 광고 파트너와 공유할 수 있습니다. 이를 통해 제3자 광고 네트워크는 귀하에게 보다 관련성 높은 맞춤형 광고를 제공할 수 있습니다.
      </p>
      <p>
        당사는 개인을 식별할 수 있는 요소를 제거한 익명 데이터를 제3자와 공유할 수 있습니다. 또한 귀하와 직접 연결되지 않는 방식으로 다른 정보와 결합한 집계 정보를 공유할 수 있습니다.
      </p>

      <h2>기타 웹사이트 및 서비스</h2>
      <p>
        당사 서비스와 연결된 기타 웹사이트 또는 서비스의 행위(해당 사이트/서비스가 제공하는 정보 또는 콘텐츠 포함)에 대해 당사는 책임을 지지 않습니다. 귀하가 링크를 통해 당사 서비스에서 다른 웹사이트나 서비스로 이동하는 경우, 본 개인정보 처리방침은 해당 제3자 사이트/서비스에 적용되지 않습니다. 제3자 사이트/서비스에서의 탐색 및 상호작용은 해당 제3자의 규칙과 정책이 적용됩니다. 또한 귀하가 사용자 콘텐츠 접근을 허용한 제3자에 대해 당사는 책임이나 통제권이 없습니다. 제3자 서비스 이용 및 접근 허용에 따른 위험은 귀하가 부담합니다.
      </p>

      <h2>문의 방법</h2>
      <p>
        본 개인정보 처리방침 또는 서비스에 관해 문의사항이 있는 경우 <a href="mailto:solovetime@163.com">solovetime@163.com</a> 으로 연락해 주세요.
      </p>

      <h2>개인정보 처리방침 변경</h2>
      <p>
        TimeEcho는 본 개인정보 처리방침을 수시로 수정하거나 업데이트할 수 있습니다. 정기적으로 확인해 주세요. 필요한 경우 다른 형태의 공지로 변경 사항을 안내할 수 있습니다. 본 처리방침이 변경된 이후에도 TimeEcho 또는 서비스를 계속 이용하는 경우, 해당 변경에 동의한 것으로 간주됩니다.
      </p>
    `,
  },
  fr: {
    title: 'Politique de confidentialité',
    updated: 'Dernière mise à jour : 10 mai 2023',
    html: `
      <p>
        Bienvenue sur TimeEcho. TimeEcho est un logiciel de suivi du temps inspiré de la méthode de gestion du temps de Lioubichtchev, conçu pour vous aider à mieux vous concentrer sur le présent, distinguer travail et vie personnelle, et développer une vision de long terme.
      </p>
      <p>
        Cette Politique de confidentialité explique comment nous et certains partenaires collectons, utilisons, partageons et protégeons les informations liées à nos services mobiles, notre site web, et tout logiciel fourni sur TimeEcho ou en lien avec ses services (ensemble, les « Services »), ainsi que les choix qui vous sont proposés.
      </p>
      <p>
        L’utilisation de nos Services signifie que vous comprenez et acceptez que nous fournissons principalement des outils logiciels de minuterie et de suivi via les Services concernés.
      </p>

      <h2>Informations que nous collectons</h2>
      <h3>Informations que vous nous fournissez directement</h3>

      <h3>Informations d’analyse</h3>
      <p>
        Nous utilisons des outils d’analyse tiers pour mesurer le trafic et les tendances d’utilisation des Services. Ces outils collectent les informations envoyées par votre appareil ou par nos Services, y compris les pages consultées, modules additionnels, et autres informations utiles pour améliorer les Services. Nous utilisons ces informations avec des données d’analyse collectées auprès d’autres utilisateurs afin qu’elles ne permettent pas d’identifier directement une personne.
      </p>

      <h3>Identifiants d’appareil</h3>
      <p>
        Lorsque vous accédez aux Services à partir d’un appareil mobile (tablette, téléphone, etc.), nous pouvons accéder à, collecter, surveiller, stocker et/ou stocker à distance un ou plusieurs « identifiants d’appareil ». Les identifiants d’appareil sont de petits fichiers de données ou structures similaires stockés sur votre appareil mobile ou associés à celui-ci, utilisés pour identifier de manière unique votre appareil. Ils peuvent inclure des données liées au matériel, au système d’exploitation, à d’autres logiciels, ou des données envoyées à l’appareil par LATTE.
      </p>
      <p>
        Les identifiants d’appareil peuvent nous fournir, ainsi qu’à nos partenaires tiers, des informations sur votre navigation et votre usage des Services, et nous aider à fournir des rapports, contenus ou publicités personnalisés. Si l’utilisation ou la disponibilité des identifiants d’appareil est limitée ou désactivée, certaines fonctionnalités des Services peuvent ne pas fonctionner correctement.
      </p>

      <h2>Comment nous utilisons vos informations</h2>
      <p>En plus des usages spécifiques décrits dans cette Politique, nous pouvons utiliser les informations reçues pour :</p>
      <ul>
        <li>développer et tester de nouveaux produits et fonctionnalités ;</li>
        <li>diagnostiquer ou résoudre des problèmes techniques.</li>
      </ul>

      <h2>Partage de vos informations</h2>
      <p>
        Sauf indication contraire dans cette Politique, nous ne prêtons ni ne vendons vos informations à des tiers extérieurs à TimeEcho (ou au groupe de sociétés auquel TimeEcho appartient) sans votre consentement.
      </p>
      <p>
        Nous pouvons partager vos informations avec des organismes tiers qui nous aident à fournir les Services (« prestataires de services »), ainsi que des informations issues d’outils tels que les cookies, fichiers journaux, identifiants d’appareil et données de localisation. Nos prestataires de services ne peuvent accéder à vos informations qu’en cas de nécessité et sous réserve d’obligations de confidentialité raisonnables.
      </p>
      <p>
        Nous pouvons également partager certaines informations, telles que les données de cookies, avec des partenaires publicitaires tiers. Ces informations permettent aux réseaux publicitaires de proposer des contenus publicitaires ciblés qu’ils estiment les plus pertinents.
      </p>
      <p>
        Nous pouvons supprimer les éléments permettant votre identification et partager des données anonymisées. Nous pouvons aussi combiner vos informations avec d’autres données d’une manière qui ne vous identifie plus personnellement, puis partager ces données agrégées.
      </p>

      <h2>Autres sites et services</h2>
      <p>
        Nous ne sommes pas responsables des pratiques des sites ou services liés à nos Services, y compris des informations ou contenus qu’ils fournissent. Lorsque vous suivez un lien depuis nos Services vers un autre site ou service, cette Politique de confidentialité ne s’applique pas à ces tiers. Votre navigation et vos interactions sur ces sites/services tiers sont régies par leurs propres règles et politiques. Vous acceptez également que nous ne soyons pas responsables et n’ayons aucun contrôle sur les tiers auxquels vous autorisez l’accès à votre contenu utilisateur. Si vous utilisez un service tiers et lui autorisez l’accès à votre contenu utilisateur, vous le faites à vos propres risques.
      </p>

      <h2>Comment nous contacter</h2>
      <p>
        Pour toute question concernant cette Politique de confidentialité ou les Services, veuillez nous contacter à <a href="mailto:solovetime@163.com">solovetime@163.com</a>.
      </p>

      <h2>Modifications de notre Politique de confidentialité</h2>
      <p>
        TimeEcho peut modifier ou mettre à jour cette Politique de confidentialité de temps à autre ; veuillez la consulter régulièrement. Nous pouvons aussi fournir d’autres formes de notification en cas de mise à jour, lorsque cela est approprié. En continuant à utiliser TimeEcho ou les Services après une modification, vous acceptez ces changements.
      </p>
    `,
  },
};
